import { SOURCING_AGENT_FORM_BASE } from './constants';

export const addProtocolToUrl = (url) => {
  if (!url || url === '') return url;

  if (url.startsWith('http')) {
    return url;
  }

  return `https://${url}`;
};

export const getDomainName = () => {
  const domainTokens = window.location.hostname.split('.');
  let domain = domainTokens[domainTokens.length - 1];

  if (domainTokens.length > 1) {
    domain = `${domainTokens[domainTokens.length - 2]}.${domain}`;
  }

  return domain;
};

// This is the raw forms URL. To prefill fields, you need the "entry.<field_id>" for each field.
// For example:
// https://docs.google.com/forms/d/e/1FAIpQLSctWwX4g1ul1Pg9h47odY5bEheek2aEm9cItoO-ylCPuAJjAA/viewform?usp=pp_url&entry.123456=email@example.com

export function getSourcingAgentFormUrl({ email, jobUrl } = {}) {
  // entry.1592903413 = email
  // entry.854158062 = jobUrl
  const params = [];
  if (email) {
    params.push(`entry.1592903413=${encodeURIComponent(email)}`);
  }
  if (jobUrl) {
    params.push(`entry.854158062=${encodeURIComponent(jobUrl)}`);
  }
  if (params.length > 0) {
    return `${SOURCING_AGENT_FORM_BASE}?usp=pp_url&${params.join('&')}`;
  }
  return SOURCING_AGENT_FORM_BASE;
}

/**
 * Generates a link to the jobs page with proper visibility filter
 * Jobs page URL with visibility=visible if not company-profile
 */
export const getJobsLink = ({ networkSlug, companySlug, isCompanyProfile = false }) => {
  let basePath;

  if (companySlug) {
    // Company jobs page
    const prefix = isCompanyProfile ? 'company-profile' : 'companies';
    basePath = `/networks/${networkSlug}/${prefix}/${companySlug}/jobs`;
  } else {
    // Main jobs page
    basePath = `/networks/${networkSlug}/jobs`;
  }

  // Add visibility=visible for non-company-profile routes
  if (!isCompanyProfile) {
    return `${basePath}?visibility=visible`;
  }

  return basePath;
};
